<div fxFlex="100%" fxLayout="row" *ngIf="candidateStage">
  <mat-table [dataSource]="candidateStage?.items?.[0]?.etapas" fxFlex="100%">
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef> STATUS </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index">
        <div
          class="timeline-dot"
          [ngClass]="{ concluida: element.concluida, pendente: !element.concluida }"
        ></div>
        <div *ngIf="i < candidateStage.items[0].etapas.length - 1" class="timeline-line"></div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="nome">
      <mat-header-cell *matHeaderCellDef fxFlex="30%"> ETAPA </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="30%"> {{ element.nome }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="data">
      <mat-header-cell *matHeaderCellDef> DATA </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.concluida ? (element.data | date) : 'PENDENTE' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="descricao">
      <mat-header-cell *matHeaderCellDef fxFlex="30%"> DESCRIÇÃO </mat-header-cell>
      <mat-cell *matCellDef="let element" fxFlex="30%"> {{ element.descricao }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="concluida">
      <mat-header-cell *matHeaderCellDef> CONCLUÍDA </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.concluida ? 'Sim' : 'Não' }} </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="['status', 'nome', 'data', 'descricao', 'concluida']"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: ['status', 'nome', 'data', 'descricao', 'concluida']"
    ></mat-row>
  </mat-table>
</div>
